import { Carousel } from "react-bootstrap";

export default function Hero({ data }) {
  const { title, content, destination, buttonLabel } = data;

  return (
    <section className="banner py-5">
      <div className="container">
        <div className="row align-items-center g-5">
          {/* Hero Content */}
          <div className="col-lg-6">
            <span className="hero-eyebrow">A SWEET ESCAPE</span>

            <h1 className="banner-title">{title}</h1>

            <p className="banner-content">{content}</p>

            <div>
              <a href={destination} className="banner-button">
                {buttonLabel}
              </a>
            </div>
          </div>

          {/* Hero Images */}
          <div className="col-lg-6">
            <Carousel controls={false} indicators={false} interval={3000}>
              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src="https://images.pexels.com/photos/5112581/pexels-photo-5112581.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  alt="Customizable treat boxes"
                />
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src="https://images.pexels.com/photos/227432/pexels-photo-227432.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  alt="Gourmet and gluten-free desserts"
                />
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100 carousel-img"
                  src="https://images.pexels.com/photos/295043/pexels-photo-295043.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                  alt="Dessert delivery"
                />
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </div>
    </section>
  );
}
